<template>
  <div class="risk-findings-container">
    <a
      v-if="!!scan.document_path"
      :href="scan.document_path"
      @click.prevent="$emit('on-doc-title-click')"
      class="m-0 t--weight-bold t--body"
    >
      {{ scan.title }}
    </a>
    <p v-else class="m-0 t--body t--weight-bold">{{ scan.title }}</p>
    <div>
      <nr-tag
        @on-click="$emit('on-review-status-click')"
        clickable
        :label="setReviewStatusText"
        :tag-color="setReviewStatusColor"
        icon-color="white"
        size="normal"
        icon="check-circle"
        icon-position="left"
      />
      <nr-tag
        :label="setSeverityText"
        :tag-color="setSeverityColor"
        size="normal"
      />
    </div>
    <div class="document-details">
      <div v-if="isScannable">
        <template v-if="scan.findings.length">
          <div
            class="m-top-24 scan-findings-panel"
            v-for="finding in scan.findings"
            :key="finding.id"
          >
            <div>
              <div class="t--weight-bold">
                {{ finding.category }}
              </div>
              <div
                class="m-top-4"
                v-for="(item, index) in finding.items"
                :key="`${finding.id}-item-${index}`"
              >
                <nr-tag :label="item.count" :badge="true" /> {{ item.type }}
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="m-top-24 scan-findings-panel">
            No results found during risk scan.
          </div>
        </template>
      </div>
      <div v-else-if="isPending">
        <div class="m-top-24 scan-findings-panel">
          This document has not been scanned.
        </div>
      </div>
      <div v-else>
        <div class="m-top-24 scan-findings-panel">
          This document is not scannable due to its filetype.
        </div>
      </div>
      <div class="doc-info-panel">
        <div class="t--weight-bold">Document Information</div>
        <div class="t--weight-semi-bold m-top-8">Request</div>
        <div>{{ scan.pretty_id }}</div>
        <div class="t--weight-semi-bold m-top-12">Visibility</div>
        <div class="t--capitalize">{{ scan.visibility }}</div>
        <div class="t--weight-semi-bold m-top-12">Upload date</div>
        <div>{{ uploadDate }}</div>
        <div class="t--weight-semi-bold m-top-12">File type</div>
        <div>{{ scan.file_type.toUpperCase() }}</div>
        <div class="t--weight-semi-bold m-top-12">File size</div>
        <div>{{ fileSize }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import NrTag from '@nextrequestco/components/src/components/NrTag'
import {
  humanizedSeverityStatus,
  severityStatusColor
} from '../../admin/document_severity_status'
import {
  humanizedReviewStatus,
  reviewStatusColor
} from '../../admin/document_review_status'
import { format as formatDate } from 'date-fns'

export default {
  name: 'risk-findings',
  props: {
    scan: {
      type: Object
    }
  },
  components: {
    'nr-tag': NrTag
  },
  computed: {
    setSeverityText() {
      return humanizedSeverityStatus(this.scan.severity)
    },

    setSeverityColor() {
      return severityStatusColor(this.scan.severity)
    },

    setReviewStatusText() {
      return humanizedReviewStatus(this.scan.review_status)
    },

    setReviewStatusColor() {
      return reviewStatusColor(this.scan.review_status)
    },

    uploadDate() {
      return formatDate(new Date(this.scan.upload_date), 'MM/dd/yyyy')
    },
    fileSize() {
      return +this.scan.file_size ? `${this.scan.file_size}mb` : '--'
    },
    isScannable() {
      return this.scan.severity !== 'na' || !this.scan.severity
    },
    isPending() {
      return !this.scan.severity
    }
  },
  methods: {
    ...mapActions('admin', ['setDocReviewStatus'])
  }
}
</script>
<style lang="scss">
@import '@nextrequestco/components/src/styles/colors.scss';
@import '../../../../styles/base/_sizes.scss';
@import '../../../../styles/base/_spacing.scss';
@import '../../../../styles/base/_typography.scss';

.risk-findings-container {
  max-width: 100%;

  button {
    padding: 1px 6px;
  }

  .document-details {
    display: flex;
  }

  .doc-info-panel {
    margin-left: auto;
    background-color: $white-ter;
    padding: 12px;
    border-radius: 8px;
  }
}
</style>
